import { Outlet, useLocation } from "react-router-dom";
import { SidebarProvider } from "../ui";
import { Sidebar } from "./Sidebar";
import { cn } from "@/lib/utils";
import { Header } from "./Header";
import { menus } from "./utils";

const Layout = () => {
  const location = useLocation();

  const CurrentMenu = menus?.find((menu: any) =>
    location?.pathname?.includes(menu.to)
  );

  return (
    <>
      <SidebarProvider>
        <div className="flex flex-row">
          <main className="bg-white fixed h-[100%] mt-[55px] hidden lg:block border-r border-g-100 w-[230px]">
            <Sidebar />
          </main>
          <div>
            <Header />
            <div
              className={cn(
                "w-[100vw] mt-[55px] bg-[#F4F5F8] text-start transition-all duration-300 ease-in-out",
                "lg:w-[calc(100vw-230px)] lg:ml-[230px]",
                "h-[calc(100vh-55px)] overflow-y-auto"
              )}
            >
              <div className="bg-white border-b border-g-100 h-[50px] px-[20px] py-[10px] flex items-center">
                <div className="text-primary flex flex-row gap-[10px]">
                  {CurrentMenu ? <CurrentMenu.icon /> : <></>}
                  {CurrentMenu?.title}
                </div>
              </div>
              <Outlet />
            </div>
          </div>
        </div>
      </SidebarProvider>
    </>
  );
};

export default Layout;
